<div class="body-content-area tabcontent" id="link1">
  <div class="row">
    <div class="col-lg-9">
      <div class="row">
        <div class="col-lg-1 low-padding text-center">
          <!-- <img *ngIf="this.SelectedMenu.Image!=null" src={{this.SelectedMenu.Image}} class="body-icon" alt="Icon"/> -->
        </div>
        <div class="col-lg-10 clear-padding">
          <div>
            <span class="page-title">Employee Tour Status</span>
            <small class="page-description"></small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!(this.CanViewState)">
    <fieldset class="body-form-control" > 
      <legend class="legend--">Employee Details</legend>
      <form #SearchForm="ngForm">
        <div class="row">
          <div class="col-lg-4">
            <div class="col-body-border-right">
              <div class="form-group row">
                <label class="col-sm-2 col-form-label clear-padding-right">Employee</label>
                <div class="col-sm-9 clear-left-padding">
                  <angular2-multiselect class="form-control" [data]="emp" [(ngModel)]="selectedItems" name="EmpId" [settings]="EmployeeSettings"
                    (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)">
                  </angular2-multiselect>
                </div>
                <div class="required-validation" *ngIf="ModelListApplication.EmployeeId == 0">Employee is required</div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label clear-padding-right">Status</label>
                <div class="col-sm-7 clear-left-padding">
                  <select [(ngModel)]="this.ModelListApplication.Status" id ="Status" (ngModelChange)="StatusChanged()" class="form-control" name="Status" required>
                    <option [value]="0" [disabled]=true >Select Status</option>
                    <option [value]="1">Pending</option>
                    <option [value]="2">Approved</option>
                    <option [value]="3">Rejected</option>
                  </select>
                </div>
                <div class="required-validation" *ngIf="this.ModelListApplication.Status == 0">Status is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="col-body-border-right">
              <div class="form-group row">
                <label class="col-sm-4 col-form-label clear-padding-right">From Date</label>
                <div class="col-sm-7 clear-left-padding">
                  <input type="date" name="SearchFromDate" [ngModel]="ModelListApplication.SearchFromDate | date:'yyyy-MM-dd'" (ngModelChange)="SearchFromDateChanged($event)" #SearchFromDate="ngModel" required/>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-sm-7 clear-left-padding">
                <button type="submit" (click)="submitClick()" class="btn btn-primary save-button" [disabled]="!(SearchForm.valid && this.ModelListApplication.Status > 0 && this.DisableSave == true && this.validdate == false && this.validTodate == false)">Generate</button>   
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group row">
              <label class="col-sm-4 col-form-label clear-padding-right">To Date</label>
              <div class="col-sm-7 clear-left-padding">
                <input type="date" name="SearchToDate" [ngModel]="ModelListApplication.SearchToDate | date:'yyyy-MM-dd'" (ngModelChange)="SearchToDateChanged($event)" #SearchToDate="ngModel" required/>
              </div>
            </div>
          </div>
        </div>
      </form>  
    </fieldset>

    <div *ngIf="PendingMsg" style="color: #dc3545; text-align: center;font-size: 15px; font-weight: bold;">No Pending Application is Found.</div>
    <div *ngIf="ApprovedMsg" style="color: #dc3545; text-align: center;font-size: 15px; font-weight: bold;">No Approved Application is Found.</div>
    <div *ngIf="RejectedMsg" style="color: #dc3545; text-align: center;font-size: 15px; font-weight: bold;">No Rejected Application is Found.</div>
    <div *ngIf="validdate" style="color: #dc3545; text-align: center;font-size: 15px; font-weight: bold;">Date From is not Valid Date.</div>
    <div *ngIf="validTodate" style="color: #dc3545; text-align: center;font-size: 15px; font-weight: bold;">Date To is not Valid Date.</div>

    <fieldset class="body-form-control" *ngIf="ApplicationPending.length > 0">
      <legend class="legend--">Employee Tour Pending</legend>
        <form #EmployeePending="ngForm">
          <div lass="row" >
            <table id="tblLeavePending" class="table table-striped table-bordered text-center table-new row-border hover">
              <thead class="thead-blue text-center">
                <tr>
                  <th>Sl.No.</th>
                  <th>Application Date</th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th class="text-left">Tour Place</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let app of ApplicationPending, let i = index">
                  <td scope="row">{{i+1}}</td>
                  <td>{{app.ApplyDate | date : "dd-MMM-yyyy"}}</td>
                  <td>{{app.FromDate | date : "dd-MMM-yyyy"}}</td>
                  <td>{{app.ToDate | date : "dd-MMM-yyyy"}}</td>
                  <td class="text-left">{{app.TourPlace}}</td>
                  <td>
                    <button type="button" (click)="viewAppliedTour(app.TourId,template)" class="table-remove-btn" type="button"><i class="fas fa-trash-alt"></i></button>
                  </td>
                </tr>
              </tbody>
              <tfoot class="thead-blue text-center">
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tfoot>
            </table>
          </div>
        </form>
    </fieldset>
  
    <fieldset class="body-form-control" *ngIf="ApplicationApproved.length > 0">
      <legend class="legend--">Employee Tour Approved</legend>
        <form #EmployeePending="ngForm">
          <div lass="row" >
            <table id="tblLeavePending" class="table table-striped table-bordered text-center table-new row-border hover">
              <thead class="thead-blue text-center">
                <tr>
                  <th>Sl.No.</th>
                  <th>Application Date</th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th class="text-left">Tour Place</th>
                  <th class="text-left">Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let app of ApplicationApproved, let i = index">
                  <td scope="row">{{i+1}}</td>
                  <td>{{app.ApplyDate | date : "dd-MMM-yyyy"}}</td>
                  <td>{{app.FromDate | date : "dd-MMM-yyyy"}}</td>
                  <td>{{app.ToDate | date : "dd-MMM-yyyy"}}</td>
                  <td class="text-left">{{app.TourPlace}}</td>
                  <td class="text-left">{{app.Remarks}}</td>
                </tr>
              </tbody>
              <tfoot class="thead-blue text-center">
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tfoot>
            </table>
          </div>
        </form>
    </fieldset>
  
    <fieldset class="body-form-control" *ngIf="ApplicationRejected.length > 0">
      <legend class="legend--">Employee Tour Rejected</legend>
        <form #EmployeePending="ngForm">
          <div lass="row" >
            <table id="tblLeavePending" class="table table-striped table-bordered text-center table-new row-border hover">
              <thead class="thead-blue text-center">
                <tr>
                  <th>Sl.No.</th>
                  <th>Application Date</th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th class="text-left">Tour Place</th>
                  <th class="text-left">Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let app of ApplicationRejected, let i = index">
                  <td scope="row">{{i+1}}</td>
                  <td>{{app.ApplyDate | date : "dd-MMM-yyyy"}}</td>
                  <td>{{app.FromDate | date : "dd-MMM-yyyy"}}</td>
                  <td>{{app.ToDate | date : "dd-MMM-yyyy"}}</td>
                  <td class="text-left">{{app.TourPlace}}</td>
                  <td class="text-left">{{app.Remarks}}</td>
                </tr>
              </tbody>
              <tfoot class="thead-blue text-center">
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </tfoot>
            </table>
          </div>
        </form>
    </fieldset>

    <div style=" box-align: center; width: 1500px;" >
      <ng-template #template>
        <div class="modal-header" style="background: #2a9bd7; max-width: 1500px;"> 
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()" style="color:#fff;">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div  style="text-align: center; max-width: 1500px;">
          <div *ngIf="CancelMsg" style="color: #dc3545; text-align: center;font-size: 15px; font-weight: bold;">Tour Application Cancel Successfully</div>
          <div style=" width: 100%;" *ngIf="ShowPopup">

            <fieldset class="body-form-control" style=" text-align:left;"> 
              <legend class="legend--">Tour Application</legend>
              <form #EmployeeTour="ngForm">
                <div class="row"> 
                  <div class="col-lg-4">
                    <div class="col-body-border-right">
                      <div class="form-group row">
                        <label  class="col-sm-4 col-form-label clear-padding-right">Code</label>
                        <div class="col-sm-7 clear-left-padding">
                          :&nbsp;&nbsp;{{this.ModelListApplication.EmployeeCode}}
                        </div>
                      </div>
                      <div class="form-group row">
                        <label  class="col-sm-4 col-form-label clear-padding-right">From Date</label>
                        <div class="col-sm-7 clear-left-padding">
                          :&nbsp;&nbsp;{{this.ModelListApplication.FromDate| date : "dd-MMM-yyyy"}}
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-sm-4 col-form-label clear-padding-right">Tour Place</label>
                        <div class="col-sm-7 clear-left-padding">
                          :&nbsp;&nbsp;{{this.ModelListApplication.TourPlace}}
                        </div>
                      </div>         
                    </div>  
                  </div>
          
                  <div class="col-lg-4">
                    <div class="col-body-border-right">
                      <div class="form-group row">
                        <label  class="col-sm-4 col-form-label clear-padding-right">Name</label>
                        <div class="col-sm-7 clear-left-padding">
                          :&nbsp;&nbsp;{{this.ModelListApplication.EmployeeName}}
                        </div>
                      </div>
                      <div class="form-group row">
                        <label  class="col-sm-4 col-form-label clear-padding-right">To Date</label>
                        <div class="col-sm-7 clear-left-padding">
                          :&nbsp;&nbsp;{{this.ModelListApplication.ToDate| date : "dd-MMM-yyyy"}}
                        </div>
                      </div>
                      <div class="form-group row">
                          <label class="col-sm-4 col-form-label clear-padding-right">Remarks</label>
                          <div class="col-sm-7 clear-left-padding">
                              <input type="text" tabindex="3" [(ngModel)]="ModelListApplication.Remarks" maxlength="500" id ="Remarks" name="Remarks" #Remarks="ngModel" required class="form-control form-control-custom form-control-custom-new">
                          </div>
                          <div *ngIf="Remarks.invalid && (Remarks.dirty || Remarks.touched)" class="alert alert-danger">
                            <div *ngIf="Remarks.errors.required">Remarks is required.</div>
                            <div *ngIf="Remarks.errors.maxlength">Remarks is not more than 500 characters</div>
                          </div>
                        </div>
                    </div> 
                  </div>
          
                  <div class="col-lg-4">
                    <div class="form-group row">
                      <label  class="col-sm-4 col-form-label clear-padding-right">Approver</label>
                      <div class="col-sm-7 clear-left-padding">
                        :&nbsp;&nbsp;{{this.ModelListApplication.RHName}} 
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-4 col-form-label clear-padding-right">RH EMail</label>
                      <div class="col-sm-7 clear-left-padding">
                        :&nbsp;&nbsp;{{this.ModelListApplication.RHEmailId}} 
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-6 col-form-label text-center clear-padding-right">
                        <button type="submit" tabindex="2" (click)="TourCancel(template)" class="btn btn-primary save-button" [disabled]="!(EmployeeTour.valid && this.DisableSave==true)">Cancel Tour</button>  
                      </label>
                    </div>
                  </div> 
                </div> 
              </form>
            </fieldset>
          </div>

          <button type="button" aria-label="Close" (click)="modalRef.hide()" style="background: #2a9bd7; outline: 0px none; border: 0px none; color: #fff; padding: 5px 10px; border-radius: 3px;">
            <span>Close</span>
          </button>             
        </div>
      </ng-template>
    </div>
  </div>
</div>